import * as React from 'react';

const BinanceIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F3BA2F",
        d: "m6.43 8.56 3.5-3.5 3.49 3.5 2.03-2.03L9.92 1 4.4 6.53zM4.99 10 2.96 7.97.92 10l2.04 2.03zM6.43 11.44l3.5 3.5 3.49-3.5 2.03 2.03L9.92 19 4.4 13.47zM16.89 12.03 18.92 10 16.9 7.97 14.85 10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F3BA2F",
        d: "M11.99 10 9.92 7.93 8.4 9.46l-.18.18-.36.36 2.06 2.07z"
    }));

export { BinanceIcon };
//# sourceMappingURL=Binance.mjs.map
